<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <img src="@/assets/images/logo/logo.png" width="70" alt="Informes SBG"/>
      <h2 class="brand-text text-primary ml-1">
        Informes SBG
      </h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          Página no encontrada 🕵🏻‍♀️
        </h2>
        <p class="mb-2">
          ¡Oh no! 😖 El URL requerido no fue encontrado.
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          :to="{path:'/'}"
        >
          Regreso a inicio
        </b-button>

        <!-- image -->
        <b-img
          fluid
          :src="imgUrl"
          alt="Página de error"
        />
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import {BLink, BButton, BImg} from 'bootstrap-vue';
import store from '@/store/index';

export default {
  components: {
    BLink,
    BButton,
    BImg
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/error.svg')
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/error-dark.svg');
        return this.downImg;
      }
      return this.downImg;
    }
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
